<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Company:</span
                                        >
                                        <v-select
                                            v-model="company"
                                            class="form-control"
                                            type="text"
                                            label="name"
                                            :options="companies"
                                            :reduce="
                                                (companies) => companies.code
                                            "
                                            name="company"
                                            placeholder="Select Company"
                                            :value="
                                                (companies) => companies.code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Zone:</span
                                        >
                                        <v-select
                                            v-model="zone"
                                            type="text"
                                            label="name"
                                            :options="zones"
                                            :reduce="(zones) => zones.zone_code"
                                            placeholder="Select Zone"
                                            :value="(zones) => zones.zone_code"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Branch:</span
                                        >
                                        <v-select
                                            v-model="branch"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="From Date"
                                            v-model="fromdate"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="To Date"
                                            v-model="todate"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Division:</span
                                        >
                                        <v-select
                                            v-model="division"
                                            type="text"
                                            label="division_name"
                                            :options="divisions"
                                            :reduce="
                                                (divisions) =>
                                                    divisions.division_code
                                            "
                                            placeholder="Select Division"
                                            :value="
                                                (divisions) =>
                                                    divisions.division_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="getStats"
                                        >
                                            Generate
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!--                        <div class="row">-->
                            <!--                            -->
                            <!--                        </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            <div class="col-md-12">
                <div class="row" align="center">
                    <div class="col-lg-6 col-6">
                        <!-- small box -->
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>
                                    {{ saleordertotal | dotNumbers }} ({{
                                        saleordercount
                                    }})
                                </h3>
                                <p>Sale Order Value</p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-pie-graph"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-6">
                        <!-- small box -->
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>
                                    {{ invoicetotal | dotNumbers }} ({{
                                        invoicecount
                                    }})
                                </h3>
                                <p>Invoice Value</p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-bag"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead class="thead-dark">
                                <tr>
                                    <th style="width: 10%">Branch</th>
                                    <th
                                        v-if="
                                            division == '' || division == 'HAP'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        HOME APPLIANCES
                                    </th>
                                    <th
                                        v-if="
                                            division == '' || division == 'ITL'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        IT
                                    </th>
                                    <th
                                        v-if="
                                            division == '' || division == 'MOB'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        MOBILES
                                    </th>
                                    <th
                                        v-if="
                                            division == '' || division == 'SER'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        SERVICES
                                    </th>
                                    <th
                                        v-if="
                                            division == '' || division == 'VAS'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        VAS
                                    </th>
                                    <th
                                        v-if="
                                            division == '' || division == 'XTR'
                                        "
                                        colspan="2"
                                        style="width: 15%"
                                    >
                                        XTRA
                                    </th>
                                </tr>
                                <tr>
                                    <td style="width: 100%"></td>
                                    <td
                                        v-if="
                                            division == '' || division == 'HAP'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'HAP'
                                        "
                                    >
                                        Invoices
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'ITL'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'ITL'
                                        "
                                    >
                                        Invoices
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'MOB'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'MOB'
                                        "
                                    >
                                        Invoices
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'SER'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'SER'
                                        "
                                    >
                                        Invoices
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'VAS'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'VAS'
                                        "
                                    >
                                        Invoices
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'XTR'
                                        "
                                    >
                                        Sale Orders
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'XTR'
                                        "
                                    >
                                        Invoices
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="branch in statbranches">
                                    <td>
                                        {{ branch.fullname }}
                                        <span
                                            class="badge badge-secondary"
                                            @click="viewCategorySales(branch)"
                                            ><i class="fa fa-search"></i
                                            >Category</span
                                        >
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'HAP'
                                        "
                                    >
                                        {{
                                            branch["HAP"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["HAP"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'HAP'
                                        "
                                    >
                                        {{
                                            branch["HAP"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["HAP"].invoicecount }})
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'ITL'
                                        "
                                    >
                                        {{
                                            branch["ITL"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["ITL"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'ITL'
                                        "
                                    >
                                        {{
                                            branch["ITL"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["ITL"].invoicecount }})
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'MOB'
                                        "
                                    >
                                        {{
                                            branch["MOB"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["MOB"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'MOB'
                                        "
                                    >
                                        {{
                                            branch["MOB"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["MOB"].invoicecount }})
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'SER'
                                        "
                                    >
                                        {{
                                            branch["SER"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["SER"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'SER'
                                        "
                                    >
                                        {{
                                            branch["SER"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["SER"].invoicecount }})
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'VAS'
                                        "
                                    >
                                        {{
                                            branch["VAS"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["VAS"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'VAS'
                                        "
                                    >
                                        {{
                                            branch["VAS"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["VAS"].invoicecount }})
                                    </td>

                                    <td
                                        v-if="
                                            division == '' || division == 'XTR'
                                        "
                                    >
                                        {{
                                            branch["XTR"].saleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["XTR"].saleordercount }})
                                    </td>
                                    <td
                                        v-if="
                                            division == '' || division == 'XTR'
                                        "
                                    >
                                        {{
                                            branch["XTR"].invoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch["XTR"].invoicecount }})
                                    </td>

                                    <!--                            <td>-->
                                    <!--                                &lt;!&ndash;									<button class="btn btn-danger" @click="view(order)" v-if="order.approved_by == null"">View</button>&ndash;&gt;-->
                                    <!--                                <button class="btn btn-primary" @click="edit(order)" v-if="order.approved_by == null"">Edit</button>-->
                                    <!--                                <button class="btn btn-success" v-if="order.approved_by != null"">REQUEST APPROVED</button>-->
                                    <!--                                <p v-if="order.approved_by != null">BY: {{order.approved_by.user_detail}}</p>-->
                                    <!--                            </td>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--                <div class="card-footer">-->
                    <!--                    <pagination :pagination="pagination"-->
                    <!--                                @prev="getOrders(pagination.prevPageUrl)"-->
                    <!--                                @next="getOrders(pagination.nextPageUrl)"-->
                    <!--                    ></pagination>-->
                    <!--                </div>-->
                </div>
            </div>
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
        <loading :show="lshow" :label="llabel"> </loading>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination, loading },

    created() {
        if (typeof this.$route.params.branch !== "undefined") {
            this.branch = this.$route.params.branch;
            this.fromdate = this.$route.params.from;
            this.todate = this.$route.params.to;
            // this.getStats();
        }
        this.getCompanies();
        this.getZones();
        this.getDivisions();
        this.getBranches();
        this.fromdate = new Date().toISOString().slice(0, 10);
        this.todate = new Date().toISOString().slice(0, 10);
        // this.getStats();
    },

    data() {
        let columns = [
            { width: "25%", label: "Name", name: "BRANCH_NAME" },
            { width: "25%", label: "Code", name: "BRANCH_CODE" },
            { width: "15%", label: "Phone", name: "phone" },
            { width: "20%", label: "Designated Godown", name: "status" },
            { width: "15%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            receipts: [],
            companies: [],
            divisions: [],
            branches: [],
            statbranches: [],
            saleorders: [],
            invoices: [],
            company: "",
            branch: "",
            division: "",
            saleordertotal: "Counting",
            invoicetotal: "Counting",
            saleordercount: "",
            invoicecount: "",
            fromdate: "",
            todate: "",
            zones: [],
            zone: "",
            zonename: "",
            zonecode: "",
            lshow: false,
            llabel: "Generating. Do not close or change this page...",
        };
    },

    methods: {
        reset() {
            this.fromdate = "";
            this.todate = "";
            this.company = "";
            this.branch = "";
            this.division = "";
            this.getCompanies();
            this.getZones();
            this.getDivisions();
            this.getBranches();
            this.getStats();
        },
        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },

        getZones() {
            axios
                .post("/api/getZones", {
                    results: this.results,
                    name: this.zonename,
                    zone: this.zonecode,
                })
                .then((response) => {
                    this.zones = response.data;
                });
        },

        getDivisions() {
            axios.post("/api/getDivisions").then((response) => {
                this.divisions = response.data;
            });
        },

        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },
        getStats() {
            this.receipttotal = "";
            this.saleordertotal = "";
            this.invoicetotal = "";
            toast.fire({
                icon: "warning",
                title: "Generating Report...",
            });
            this.lshow = true;
            axios
                .post("/api/dailyDivisionwiseBranchSalesSummary", {
                    fromdate: this.fromdate,
                    todate: this.todate,
                    division: this.division,
                    branch: this.branch,
                    zone: this.zone,
                    company: this.company,
                })
                .then((response) => {
                    this.statbranches = response.data.branches;
                    this.saleordercount = response.data.saleorder_count;
                    this.saleordertotal = response.data.saleorder_value;
                    this.invoicecount = response.data.invoice_count;
                    this.invoicetotal = response.data.invoice_value;
                    toast.fire({
                        title: "Generated",
                        type: "success",
                    });
                    this.lshow = false;
                })
                .catch(() => {
                    toast.fire({
                        title: "Failed! Try Again.",
                        type: "error",
                    });
                    this.lshow = false;
                });
        },
        viewSalespersonSales(branch) {
            if (this.fromdate != "") {
                this.$router.push(
                    "/reports/salespersonwise/daily-sales-value/" +
                        branch.branch_code +
                        "/" +
                        this.fromdate +
                        "/" +
                        this.todate
                );
            } else
                this.$router.push(
                    "/reports/salespersonwise/daily-sales-value/" +
                        branch.branch_code
                );
        },

        viewCategorySales(branch) {
            if (this.fromdate != "") {
                this.$router.push(
                    "/reports/branchwise/daily-category-value/" +
                        branch.branch_code +
                        "/" +
                        this.fromdate +
                        "/" +
                        this.todate
                );
            } else
                this.$router.push(
                    "/reports/branchwise/daily-category-value/" +
                        branch.branch_code
                );
        },
    },
};
</script>
